export const prohibitedQuery = [
  // Data Modification
  "INSERT",
  "UPDATE",
  "DELETE",
  "MERGE",
  "WITH",

  // Schema Modification
  "CREATE",
  "ALTER",
  "DROP",
  "TRUNCATE",
  "RENAME",

  // Transaction Control
  "BEGIN",
  "COMMIT",
  "ROLLBACK",
  "SAVE",

  // Security
  "GRANT",
  "REVOKE",
  "DENY",

  // Indexes and Constraints
  "CREATE INDEX",
  "DROP INDEX",
  "ALTER INDEX",

  // Stored Procedures, Functions, Triggers
  "EXEC",
  "EXECUTE",
  "CREATE PROCEDURE",
  "ALTER PROCEDURE",
  "DROP PROCEDURE",
  "CREATE FUNCTION",
  "ALTER FUNCTION",
  "DROP FUNCTION",
  "CREATE TRIGGER",
  "ALTER TRIGGER",
  "DROP TRIGGER",

  // Views
  "CREATE VIEW",
  "ALTER VIEW",
  "DROP VIEW",

  // Others
  // "USE",
  "SET",
  "PRINT",
  "RAISERROR",
  "BACKUP",
  "RESTORE",
  "DBCC",
  "WAITFOR",
  "KILL",
  "SHUTDOWN",
];
